import { createFileRoute } from "@tanstack/react-router";
import { CompanyDetailPage } from "@/components/admin/company-detail-page";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/companies/$id")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "companies"),
  component: AdminCompanyRoute,
});

function AdminCompanyRoute() {
  const { id } = Route.useParams();
  return <CompanyDetailPage companyId={id} />;
}
